import { render, staticRenderFns } from "./statistics_barchart.vue?vue&type=template&id=ccbf712e"
import script from "./statistics_barchart.vue?vue&type=script&lang=js"
export * from "./statistics_barchart.vue?vue&type=script&lang=js"
import style0 from "./statistics_barchart.vue?vue&type=style&index=0&id=ccbf712e&prod&coped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports